import * as React from 'react';
import { programsStore } from '../../../ProgramsStore';
import { findProgram } from '../../../ProgramsStore/Functions';
import { distanceOfTimeInWords } from '../../../Time';
import { AlreadyTranslated, T } from '../../../Translations';
import { AnnouncementResource } from '../../Decoders/Types';
import * as style from '../../style.module.css';
import Content from '../Content';

interface Props {
  announcement: AnnouncementResource;
}

const DefaultDetails: React.FC<Props> = ({ announcement }) => {
  const { payload } = announcement;

  return (
    <div className={style.details} data-test-announcement-details>
      <div className={style.timestamp} tabIndex={0}>
        <T {...distanceOfTimeInWords(new Date(), payload.createdAt)} />
      </div>
      <h3 className={style.title} tabIndex={0}>
        {payload.subject}
      </h3>
      {programsStore.resource
        .map(({ payload }) => payload.programs)
        .andThen(findProgram(payload.programId))
        .map((program) => (
          <div className={style.organization} tabIndex={0}>
            <AlreadyTranslated content={program.payload.title} />
          </div>
        ))
        .getOrElseValue(<span />)}
      <Content announcement={announcement} />
    </div>
  );
};

export default DefaultDetails;
